<template>
    <section class="textBanner py-12 lg:py-30">
        <UiExtraNarrowContent>
            <UiArticleImage :article="article" :width="Number(100)" :height="Number(110)"
                class="mb-6 w-18 h-18 rounded-full overflow-hidden" />
            <p v-html="article.content" class="text-lg"></p>

            <div v-for="n in numberOfStars" :key="n" class="star inline-block mr-1">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M9.63678 1.78747C9.77974 1.47752 10.2203 1.47752 10.3632 1.78747L12.7276 6.9134C12.7859 7.03972 12.9056 7.1267 13.0437 7.14308L18.6494 7.80772C18.9884 7.84791 19.1245 8.26687 18.8739 8.49862L14.7295 12.3313C14.6273 12.4257 14.5816 12.5664 14.6087 12.7029L15.7088 18.2396C15.7754 18.5744 15.419 18.8333 15.1211 18.6666L10.1954 15.9094C10.074 15.8414 9.92601 15.8414 9.80462 15.9094L4.87886 18.6666C4.58102 18.8333 4.22463 18.5744 4.29115 18.2396L5.39129 12.7029C5.4184 12.5664 5.37268 12.4257 5.27054 12.3313L1.12612 8.49862C0.875517 8.26687 1.01164 7.84791 1.3506 7.80772L6.95629 7.14308C7.09443 7.1267 7.21414 7.03972 7.27241 6.9134L9.63678 1.78747Z"
                        fill="#7D5B1C" />
                </svg>

            </div>
            <p class="small mt-4">
                {{ article.title }}
            </p>
        </UiExtraNarrowContent>
    </section>
</template>

<script setup lang="ts">

import { useBlogStore } from '@/stores/blogStore';
import { IconStar } from '@tabler/icons-vue';
import { computed } from 'vue';

const numberOfStars = computed(() => {
    const stars = parseInt(props.article.excerpt);
    return isNaN(stars) ? 0 : stars;
});

const blogStore = useBlogStore();

// Props
const props = defineProps({
    article: {
        type: Object,
        required: true
    }
});
</script>
